<div  style="display: inline-block; margin: auto;">
    <input class="btn btn-danger" type="button" (click)="logoutClicked()" value="Logout"/>
</div>